module.exports = __webpack_public_path__ + "19156af93053612a8cb1b72f2e736111.ttf";